import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=658835a4&scoped=true"
import script from "./sidebarItem.vue?vue&type=script&lang=js"
export * from "./sidebarItem.vue?vue&type=script&lang=js"
import style0 from "./sidebarItem.vue?vue&type=style&index=0&id=658835a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658835a4",
  null
  
)

export default component.exports